module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_cuad_14.6f2fd7ae.png";